import { render } from "./App.vue?vue&type=template&id=12809d31"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=12809d31&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/sns-pc-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__